import Swiper from "swiper";
import { Navigation, Scrollbar, A11y, Keyboard } from "swiper/modules";
import "swiper/css";

const token = (name, fallback) => parseFloat(getComputedStyle(document.documentElement).getPropertyValue(`--pk-${name}`)) || fallback;

function initKennisSlider() {
	document.querySelectorAll(".kennis_slider-layout").forEach((layout) => {
		const el = layout.querySelector(".kennis-swiper");
		if (!el || el.swiper) return;

		new Swiper(el, {
			modules: [Navigation, Scrollbar, A11y, Keyboard],
			slidesPerView: token("kennis-slider-per-view-mobile", 1.15),
			spaceBetween: token("slider-gap", 24),
			breakpoints: {
				[token("breakpoint-sm", 767) + 1]: { slidesPerView: token("kennis-slider-per-view-tablet", 2) },
				[token("breakpoint-md", 992) + 1]: { slidesPerView: token("kennis-slider-per-view", 3) },
			},
			grabCursor: true,
			watchOverflow: true,
			navigation: {
				prevEl: layout.querySelector(".pk-slider-button--prev"),
				nextEl: layout.querySelector(".pk-slider-button--next"),
			},
			scrollbar: {
				el: layout.querySelector(".pk-slider-progress"),
				draggable: true,
			},
			keyboard: { enabled: true, onlyInViewport: true },
			a11y: {
				enabled: true,
				prevSlideMessage: el.dataset.prevLabel,
				nextSlideMessage: el.dataset.nextLabel,
			},
		});
	});
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initKennisSlider);
} else {
	initKennisSlider();
}
